import React from 'react'
import TooltipBanner from './TooltipBanner'
import { getStatusIconByCode, getStatusLabelByCode } from '../../utils/statusIconHelper'

interface StatusIconWithTooltipProps {
  statusCode: string
  /** Alt text for the icon image. Defaults to the resolved status label. */
  alt?: string
}

/**
 * Status icon (On Hold / Partially Approved / Partially Denied / Overridden)
 * with a hover tooltip, shared across the Requestor and Approver list views.
 */
const StatusIconWithTooltip: React.FC<StatusIconWithTooltipProps> = ({
  statusCode,
  alt,
}) => {
  const iconSrc = getStatusIconByCode(statusCode)
  if (!iconSrc) return null

  const label = getStatusLabelByCode(statusCode)

  return (
    <TooltipBanner
      message={<span className="p3 -medium">{label}</span>}
      width="w-auto"
      padding="p-2! px-3!"
      className="whitespace-nowrap"
      tooltipContainerClass="bottom-full left-1/2 -translate-x-1/2 mb-2 z-50"
    >
      <img
        src={iconSrc}
        alt={alt ?? label}
        className="w-5 h-5"
        style={{ flexShrink: 0 }}
      />
    </TooltipBanner>
  )
}

export default StatusIconWithTooltip
